export * from '@fhs/routing/src/routes/menu/_layout';
export { default } from '@fhs/routing/src/routes/menu/_layout';
